import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  readonly supportEmail = environment.supportEmail;
}
